export var MenuLayout;
(function (MenuLayout) {
  MenuLayout["Columns"] = "Columns";
  MenuLayout["Gallery"] = "Gallery";
})(MenuLayout || (MenuLayout = {}));